var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPfp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16675 5.16667H4.50008C4.14646 5.16667 3.80732 5.30714 3.55727 5.55719C3.30722 5.80724 3.16675 6.14638 3.16675 6.5V12.5C3.16675 12.8536 3.30722 13.1928 3.55727 13.4428C3.80732 13.6929 4.14646 13.8333 4.50008 13.8333H10.5001C10.8537 13.8333 11.1928 13.6929 11.4429 13.4428C11.6929 13.1928 11.8334 12.8536 11.8334 12.5V11.8333M11.1667 3.83333L13.1667 5.83333M14.0901 4.89007C14.3526 4.62751 14.5002 4.27139 14.5002 3.90007C14.5002 3.52875 14.3526 3.17264 14.0901 2.91007C13.8275 2.64751 13.4714 2.5 13.1001 2.5C12.7288 2.5 12.3726 2.64751 12.1101 2.91007L6.50008 8.50007V10.5001H8.50008L14.0901 4.89007Z",
    stroke: "#0B0C14",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPfp);
export default __webpack_public_path__ + "static/media/edit_pfp.14157a38f06e39150abc0b6280eb0283.svg";
export { ForwardRef as ReactComponent };